import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/animations/scale.css";


export default function() {
    if (document.getElementById("language-switcher")) {
        tippy("#language-switcher", {
          content: document.getElementById("language-template").innerHTML,
          allowHTML: true,
          interactive: true,
          trigger: "click",
          placement: "bottom-end",
          animation: "scale",
          theme: "light",
        });
      }
}

